import React from "react";
import LedgerReport from "./ledgerReport";

const REPORT_TYPES = [
  { value: "roundpayment", label: "Round Payment" },
  { value: "expenseadmin", label: "Adminstrative Expense" },
  { value: "expenseinvestcapex", label: "Investement & Capital Expenses" },
  { value: "expensefina", label: "Finance Expenses" },
];

export default function ExpenseReport() {
  return (
    <LedgerReport
      name="expenseReport"
      title="Expenses:"
      partyLabel="Payee"
      reportTypes={REPORT_TYPES}
      defaultType="roundpayment"
      balanceTypes={[]}
      downloadName="expenses.xlsx"
    />
  );
}
